angular.module('zc.zenclerkS')
  .component('zcsAgencySiteList', {
    templateUrl: '/templates/zenclerk_s/agencies/sites/agency_site_list.html',
    bindings: {
      agency: '<'
    },
    controller: ZcsAgencySiteListController
  });

ZcsAgencySiteListController.$inject = ['$filter', '$scope', '$state', 'AgencyProject', 'ZcsAgencyInvoice'];
function ZcsAgencySiteListController($filter, $scope, $state, AgencyProject, ZcsAgencyInvoice) {
  const vm = this;

  vm.projects = [];
  vm.filter = '';
  vm.filteredProjects = [];
  vm.demoProjects = [];
  vm.testProjects = [];
  vm.agencyProjectsMaxInvoice = {}; // for the max invoice(上限金額) column but uses expensive mongodb query

  //actions
  vm.newSite = newSite;
  vm.filterChanged = filterChanged;

  vm.$onInit = () => {
    Promise.all([
      AgencyProject.all(vm.agency.name),
      ZcsAgencyInvoice.findAgencyApikeyMaxInvoice(vm.agency.name, moment().format('YYYY-MM')),
    ]).then(([projects, agencyProjectsMaxInvoice]) => {
      for(let project of projects) {
        if(project.is_demo) {
          vm.demoProjects.push(project);
        } else if(project.is_test) {
          vm.testProjects.push(project);
        } else {
          vm.projects.push(project);
        }
      }
      vm.agencyProjectsMaxInvoice = agencyProjectsMaxInvoice;
      filterChanged();
    });
  };

  function filterChanged() {
    vm.filteredProjects = $filter('searchProject')(vm.projects, vm.filter);
  }

  function newSite(demo) {
    return $state.go('zenclerkS.agency.sites.new', {demo});
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/sites/agency_site_list.component.js